export default __webpack_public_path__ + "c87dc532f7419cdaef0ab77da307ec00.svg";